import * as React from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import { useAuth } from 'hooks';
import routes from './routes';
import { usePermission } from 'hooks/usePermission';

const AppRoutes = () => {
  const { isLoggedIn, userBelongsToAnyOf } = useAuth();
  const { hasPermissionTo, hasAnyPermissionTo } = usePermission();
  const location = useLocation();

  const myRoutes = useRoutes([
    {
      path: '/prototipo/estadia',
      element: <Navigate to="/viagens-controle/acompanhamento" replace />,
    },
    ...routes({
      isLoggedIn,
      userBelongsToAnyOf,
      location,
      hasPermissionTo,
      hasAnyPermissionTo,
    }),
  ]);

  return <>{myRoutes}</>;
};

export default AppRoutes;
